module.exports = __webpack_public_path__ + "static/media/exit.4f5555d6.svg";